import { InjectionToken } from '@angular/core';
import { CookieConsentConfig } from '../models/cookie-consent-config.interface';

export const CookieConsentConfigToken = new InjectionToken<CookieConsentConfig>('CookieConsentConfig');
